import React, {useState, useEffect} from 'react';
import {useAuth} from "../../../helpers/AuthContext";
import Modal from "../../Modal";
import CreateCouponForm from "./CreateCouponForm";
import EditCouponForm from "./EditCouponForm";
import CouponsTable from "./CouponsTable";
import EditCouponModal from "./EditCouponModal";
import CreateCouponModal from "./CreateCouponModal";

function CouponsManager() {
    const {fetch, channel, API_URL} = useAuth();
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [couponToEdit, setCouponToEdit] = useState(null);
    const [showCreate, setShowCreate] = useState(false);

    const loadCoupons = async () => {
        setLoading(true);
        try {
            const response = await fetch(API_URL + '/v1/seller/coupons');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            setCoupons(json?.data || []);
        } catch (error) {
            console.error('Error loading coupons:', error);
            setError('Failed to load coupons. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadCoupons();
    }, [fetch]);

    let tableContent;
    if (loading) {
        tableContent = <p>Loading coupons...</p>;
    } else if (error) {
        tableContent = <p className="error">{error}</p>;
    } else if (coupons.length === 0) {
        tableContent = <p>No coupons found. Create your first coupon below!</p>;
    } else {
        tableContent = <CouponsTable
            coupons={coupons}
            onUpdate={loadCoupons}
            onClickEdit={(coupon) => setCouponToEdit(coupon)}
            onRefresh={loadCoupons}
        />;
    }

    return (
        <div>
            {tableContent}

            {couponToEdit && (
                <EditCouponModal
                    coupon={couponToEdit}
                    onClose={() => setCouponToEdit(null)}
                    onSuccess={() => {
                        setCouponToEdit(null);
                        loadCoupons();
                    }}
                />
            )}

            {showCreate && (
                <CreateCouponModal
                    onClose={() => setShowCreate(false)}
                    onSuccess={() => {
                        loadCoupons()
                            .then(() => {
                                setShowCreate(false);
                            });
                    }}
                />
            )}

            <button
                className="button primary"
                onClick={() => setShowCreate(true)}>Create New Coupon</button>
        </div>
    );

}

export default CouponsManager;